<template>
	<div>
		<hr>
		<div class="s-header-wrapper">
			<table class="s-header">
				<thead class='bold'>
					<tr>
						<td rowspan="2" class='s-td'>Субъекты, федеральные округа</td>
						<td rowspan="2" class='s-td'>Объёмы выполненных л.п. обследований (в соответствии с опубликованными на сайтах Актах ЛПО), га</td>
						<td rowspan="2" class='s-td'>Назначено мероприятий (в соответствии с опубликованными Актами ЛПО), га</td>
						<td rowspan="2" class='s-td'>Назначено мероприятий (в соответствии с поступившими Актами ЛПО), га</td>
						<td colspan='3'>из них</td>
						<td colspan='5'>в т.ч. по видам мероприятий</td>
						<td colspan='5'>в т.ч. по актам с отрицательными заключениями, га</td>
						<td class='s-scroll' rowspan="2"></td>
					</tr>
					<tr>
						<td class='s-td-small'>СОМ, га</td>
						<td class='s-td'>профилактические мероприятия</td>
						<td class='s-td'>Агитационные мероприятия</td>
						<td class='s-td-small'>ССР, га</td>
						<td class='s-td-small'>ВСР, га</td>
						<td class='s-td-small'>УНД, га</td>
						<td class='s-td-small'>РАД, га</td>
						<td class='s-td-small'>Иные, га</td>
						<td class='s-td-small'>ССР, га</td>
						<td class='s-td-small'>ВСР, га</td>
						<td class='s-td-small'>УНД, га</td>
						<td class='s-td-small'>РАД, га</td>
						<td class='s-td-small'>Иные, га</td>
					</tr>
					<tr>
						<td>1</td>
						<td>2</td>
						<td>3</td>
						<td>4</td>
						<td>5</td>
						<td>6</td>
						<td>7</td>
						<td>8</td>
						<td>9</td>
						<td>10</td>
						<td>11</td>
						<td>12</td>
						<td>13</td>
						<td>14</td>
						<td>15</td>
						<td>16</td>
						<td>17</td>
					</tr>
				</thead>
			</table>
		</div>
		<div class="s-body-wrapper">
			<table class='s-body'>			
				<tbody>
					<tr v-for='(row, i) in rows'>
						<td v-if='row.flag' colspan="17"><span class="bold">{{row.fo}}</span></td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='left s-td'>{{row.region}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td'>{{row.lpo_volume}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td'>{{row.mzl_volume_published}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td'>{{row.mzl_volume_obtained}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td-small'>{{row.mzl_volume_obtained_som}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td'>{{row.mzl_volume_obtained_prof}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td'>{{row.mzl_volume_obtained_agit}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td-small'>{{row.mzl_volume_obtained_ssr}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td-small'>{{row.mzl_volume_obtained_vsr}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td-small'>{{row.mzl_volume_obtained_und}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td-small'>{{row.mzl_volume_obtained_rad}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td-small'>{{row.mzl_volume_obtained_others}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td-small'>{{row.mzl_volume_obtained_negative_ssr}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td-small'>{{row.mzl_volume_obtained_negative_vsr}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td-small'>{{row.mzl_volume_obtained_negative_und}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td-small'>{{row.mzl_volume_obtained_negative_rad}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right s-td-small'>{{row.mzl_volume_obtained_negative_others}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import router from '../../router'
	import {DB} from './../../constants'
	import { EventBus } from '../../lib/EventBus'

	const GET_MZL_REPORT = 'get_mzl_report_v2.php'
	const REPORT_ID = 3

	export default {
		name: 'Mzl',
		data: function () {
			return {
				rows: []
			}
		},
		props: [
			'start',
			'end'
		],
		methods: {
			fillTable (start,end) {
				fetch(DB + GET_MZL_REPORT + '?start=' + start + '&end=' + end)
				.then(res => res.json())
				.then(res => {
					let temp_rows = [{}]
					let flag = true
					let total_summ = {}
					total_summ.region = 'Итого по РФ'
					total_summ.lpo_volume = 0
					total_summ.mzl_volume_published = 0
					total_summ.mzl_volume_obtained = 0
					total_summ.mzl_volume_obtained_som = 0
					total_summ.mzl_volume_obtained_prof = 0
					total_summ.mzl_volume_obtained_agit = 0
					total_summ.mzl_volume_obtained_ssr = 0
					total_summ.mzl_volume_obtained_vsr = 0
					total_summ.mzl_volume_obtained_und = 0
					total_summ.mzl_volume_obtained_rad = 0
					total_summ.mzl_volume_obtained_others = 0
					total_summ.mzl_volume_obtained_negative_ssr = 0
					total_summ.mzl_volume_obtained_negative_vsr = 0
					total_summ.mzl_volume_obtained_negative_und = 0
					total_summ.mzl_volume_obtained_negative_rad = 0
					total_summ.mzl_volume_obtained_negative_others = 0

					let fo_summ = {}
					fo_summ.region = 'Итого по округу'
					fo_summ.lpo_volume = 0
					fo_summ.mzl_volume_published = 0
					fo_summ.mzl_volume_obtained = 0
					fo_summ.mzl_volume_obtained_som = 0
					fo_summ.mzl_volume_obtained_prof = 0
					fo_summ.mzl_volume_obtained_agit = 0
					fo_summ.mzl_volume_obtained_ssr = 0
					fo_summ.mzl_volume_obtained_vsr = 0
					fo_summ.mzl_volume_obtained_und = 0
					fo_summ.mzl_volume_obtained_rad = 0
					fo_summ.mzl_volume_obtained_others = 0
					fo_summ.mzl_volume_obtained_negative_ssr = 0
					fo_summ.mzl_volume_obtained_negative_vsr = 0
					fo_summ.mzl_volume_obtained_negative_und = 0
					fo_summ.mzl_volume_obtained_negative_rad = 0
					fo_summ.mzl_volume_obtained_negative_others = 0

					let i = 0

					while (i < res.length - 1) {

						if ((res[i].fo === res[i+1].fo) && flag) {
							let obj = {}
							obj.fo = res[i].fo
							obj.flag = true
							flag = false

							if (i !== 0) {
								let clone_fo = {} //клонируем объект для передачи по значению
								for (let key in fo_summ) {
									clone_fo[key] = fo_summ[key]
								}

								temp_rows.push(clone_fo)

								fo_summ.lpo_volume = 0
								fo_summ.mzl_volume_published = 0
								fo_summ.mzl_volume_obtained = 0
								fo_summ.mzl_volume_obtained_som = 0
								fo_summ.mzl_volume_obtained_prof = 0
								fo_summ.mzl_volume_obtained_agit = 0
								fo_summ.mzl_volume_obtained_ssr = 0
								fo_summ.mzl_volume_obtained_vsr = 0
								fo_summ.mzl_volume_obtained_und = 0
								fo_summ.mzl_volume_obtained_rad = 0
								fo_summ.mzl_volume_obtained_others = 0
								fo_summ.mzl_volume_obtained_negative_ssr = 0
								fo_summ.mzl_volume_obtained_negative_vsr = 0
								fo_summ.mzl_volume_obtained_negative_und = 0
								fo_summ.mzl_volume_obtained_negative_rad = 0
								fo_summ.mzl_volume_obtained_negative_others = 0
						}

						temp_rows.push(obj)

						
					}
					else {
						total_summ.lpo_volume += +res[i].lpo_volume
						total_summ.mzl_volume_published += +res[i].mzl_volume_published
						total_summ.mzl_volume_obtained += +res[i].mzl_volume_obtained
						total_summ.mzl_volume_obtained_som += +res[i].mzl_volume_obtained_som
						total_summ.mzl_volume_obtained_prof += +res[i].mzl_volume_obtained_prof
						total_summ.mzl_volume_obtained_agit += +res[i].mzl_volume_obtained_agit
						total_summ.mzl_volume_obtained_ssr += +res[i].mzl_volume_obtained_ssr
						total_summ.mzl_volume_obtained_vsr += +res[i].mzl_volume_obtained_vsr
						total_summ.mzl_volume_obtained_und += +res[i].mzl_volume_obtained_und
						total_summ.mzl_volume_obtained_rad += +res[i].mzl_volume_obtained_rad
						total_summ.mzl_volume_obtained_others += +res[i].mzl_volume_obtained_others
						total_summ.mzl_volume_obtained_negative_ssr += +res[i].mzl_volume_obtained_negative_ssr
						total_summ.mzl_volume_obtained_negative_vsr += +res[i].mzl_volume_obtained_negative_vsr
						total_summ.mzl_volume_obtained_negative_und += +res[i].mzl_volume_obtained_negative_und
						total_summ.mzl_volume_obtained_negative_rad += +res[i].mzl_volume_obtained_negative_rad
						total_summ.mzl_volume_obtained_negative_others += +res[i].mzl_volume_obtained_negative_others

						fo_summ.lpo_volume += +res[i].lpo_volume
						fo_summ.mzl_volume_published += +res[i].mzl_volume_published
						fo_summ.mzl_volume_obtained += +res[i].mzl_volume_obtained
						fo_summ.mzl_volume_obtained_som += +res[i].mzl_volume_obtained_som
						fo_summ.mzl_volume_obtained_prof += +res[i].mzl_volume_obtained_prof
						fo_summ.mzl_volume_obtained_agit += +res[i].mzl_volume_obtained_agit
						fo_summ.mzl_volume_obtained_ssr += +res[i].mzl_volume_obtained_ssr
						fo_summ.mzl_volume_obtained_vsr += +res[i].mzl_volume_obtained_vsr
						fo_summ.mzl_volume_obtained_und += +res[i].mzl_volume_obtained_und
						fo_summ.mzl_volume_obtained_rad += +res[i].mzl_volume_obtained_rad
						fo_summ.mzl_volume_obtained_others += +res[i].mzl_volume_obtained_others
						fo_summ.mzl_volume_obtained_negative_ssr += +res[i].mzl_volume_obtained_negative_ssr
						fo_summ.mzl_volume_obtained_negative_vsr += +res[i].mzl_volume_obtained_negative_vsr
						fo_summ.mzl_volume_obtained_negative_und += +res[i].mzl_volume_obtained_negative_und
						fo_summ.mzl_volume_obtained_negative_rad += +res[i].mzl_volume_obtained_negative_rad
						fo_summ.mzl_volume_obtained_negative_others += +res[i].mzl_volume_obtained_negative_others

						for (let key in fo_summ) {
							if (key !== 'region')
								fo_summ[key] = +fo_summ[key].toFixed(2)
						}

						temp_rows.push(res[i])
						if (res[i].fo !== res[i+1].fo) {
							flag = true
						}
						i++
					}
				}

				let last = res.length - 1

				temp_rows.push(res[last])

				total_summ.lpo_volume += +res[last].lpo_volume
				total_summ.mzl_volume_published += +res[last].mzl_volume_published
				total_summ.mzl_volume_obtained += +res[last].mzl_volume_obtained
				total_summ.mzl_volume_obtained_som += +res[last].mzl_volume_obtained_som
				total_summ.mzl_volume_obtained_prof += +res[last].mzl_volume_obtained_prof
				total_summ.mzl_volume_obtained_agit += +res[last].mzl_volume_obtained_agit
				total_summ.mzl_volume_obtained_ssr += +res[last].mzl_volume_obtained_ssr
				total_summ.mzl_volume_obtained_vsr += +res[last].mzl_volume_obtained_vsr
				total_summ.mzl_volume_obtained_und += +res[last].mzl_volume_obtained_und
				total_summ.mzl_volume_obtained_rad += +res[last].mzl_volume_obtained_rad
				total_summ.mzl_volume_obtained_others += +res[last].mzl_volume_obtained_others
				total_summ.mzl_volume_obtained_negative_ssr += +res[last].mzl_volume_obtained_negative_ssr
				total_summ.mzl_volume_obtained_negative_vsr += +res[last].mzl_volume_obtained_negative_vsr
				total_summ.mzl_volume_obtained_negative_und += +res[last].mzl_volume_obtained_negative_und
				total_summ.mzl_volume_obtained_negative_rad += +res[last].mzl_volume_obtained_negative_rad
				total_summ.mzl_volume_obtained_negative_others += +res[last].mzl_volume_obtained_negative_others

				fo_summ.lpo_volume += +res[last].lpo_volume
				fo_summ.mzl_volume_published += +res[last].mzl_volume_published
				fo_summ.mzl_volume_obtained += +res[last].mzl_volume_obtained
				fo_summ.mzl_volume_obtained_som += +res[last].mzl_volume_obtained_som
				fo_summ.mzl_volume_obtained_prof += +res[last].mzl_volume_obtained_prof
				fo_summ.mzl_volume_obtained_agit += +res[last].mzl_volume_obtained_agit
				fo_summ.mzl_volume_obtained_ssr += +res[last].mzl_volume_obtained_ssr
				fo_summ.mzl_volume_obtained_vsr += +res[last].mzl_volume_obtained_vsr
				fo_summ.mzl_volume_obtained_und += +res[last].mzl_volume_obtained_und
				fo_summ.mzl_volume_obtained_rad += +res[last].mzl_volume_obtained_rad
				fo_summ.mzl_volume_obtained_others += +res[last].mzl_volume_obtained_others
				fo_summ.mzl_volume_obtained_negative_ssr += +res[last].mzl_volume_obtained_negative_ssr
				fo_summ.mzl_volume_obtained_negative_vsr += +res[last].mzl_volume_obtained_negative_vsr
				fo_summ.mzl_volume_obtained_negative_und += +res[last].mzl_volume_obtained_negative_und
				fo_summ.mzl_volume_obtained_negative_rad += +res[last].mzl_volume_obtained_negative_rad
				fo_summ.mzl_volume_obtained_negative_others += +res[last].mzl_volume_obtained_negative_others

				for (let key in fo_summ) {
					if (key !== 'region')
						fo_summ[key] = +fo_summ[key].toFixed(2)
				}

				let clone_fo = {} //клонируем объект для передачи по значению
				for (let key in fo_summ) {
					clone_fo[key] = fo_summ[key]
				}

				for (let key in total_summ) {
					if (key !== 'region')
						total_summ[key] = +total_summ[key].toFixed(2)
						// total_summ[key] = total_summ[key]
				}

				temp_rows.push(clone_fo)

				temp_rows[0] = total_summ

				this.rows = temp_rows
			})
				.catch(err => console.log(err))
			}
		},
		mounted () {
			this.fillTable(this.start, this.end)

			EventBus.$on('mzl-date', date => {
				this.fillTable(date.start, date.end)
			})

			const dispay_width = document.documentElement.clientWidth
			const dispay_height = document.documentElement.clientHeight
			let scroll_width = 17

			const ua = navigator.userAgent
			if (ua.search('OPR/') > 0) {
				scroll_width = 15
			}

			const table_width = dispay_width - 30 - scroll_width
			const col_width = Math.ceil((table_width) / 23)
			const double_col_width = 2 * col_width

			document.querySelectorAll('.s-td-small').forEach(td => {
				td.width = col_width
			})

			document.querySelectorAll('.s-td').forEach(td => {
				td.width = double_col_width
			})

			document.querySelector('.s-header-wrapper').width = table_width
			document.querySelector('.s-body-wrapper').width = table_width
			document.querySelector('.s-body-wrapper').style.maxHeight = `${dispay_height - 340}px`

			// console.log(dispay_width, col_width, table_width)

			

			// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))
			document.querySelector('.s-scroll').width = scroll_width
		},
		updated() {
			const dispay_width = document.documentElement.clientWidth
			const dispay_height = document.documentElement.clientHeight
			let scroll_width = 17

			const ua = navigator.userAgent
			if (ua.search('OPR/') > 0) {
				scroll_width = 15
			}

			const table_width = dispay_width - 30 - scroll_width
			const col_width = Math.ceil((table_width) / 23)
			const double_col_width = 2 * col_width

			document.querySelectorAll('.s-td-small').forEach(td => {
				td.width = col_width
			})
		},
		created() {
			/*if(!this.$parent.$parent.reports.some((e) => {
				return e.id == REPORT_ID
			}))
				router.replace('/main')*/
		},
		beforeDestroy() {
			EventBus.$off('mzl-date')
		}
	}
</script>

<style scoped>
	.left {
		text-align: left;
		padding-left: 2px;
	}

	.right {
		text-align: right;
		padding-right: 10px;
	}

	div.s-header-wrapper {
		border: 1px solid black;
		border-bottom: none;  
		/*width: 1607px;*/
		/*width: 1630px;*/
	}

	div.s-body-wrapper {
		overflow-x: auto;
		overflow-y: auto;
		/*width: 1624px;*/
		/*width: 1640px;*/
		max-height: 540px;
		border: 1px solid black;
		border-top: none;
	}

	table.s-header {
		border-bottom: 1px solid black;
		width: 100%;
	}

	table.s-body {
		table-layout: fixed;
		width: 100%;
	}
	
	td.s-td,  th.s-td {
		vertical-align: middle;  
		/*width: 192px;*/
		word-wrap: break-word;
		/*width: 8.6956%;*/
	}

	td.s-td-small,  th.s-td-small {
		vertical-align: middle;  
		/*width: 4.3478%;*/
		word-wrap: break-word;
	}
</style>



// WEBPACK FOOTER //
// MzlV2.vue?f1c02eae